import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import enTranslations from '../translations/en.json';

const BASE_URL = process.env.REACT_APP_PUBLIC_TRANSLATION_BASE_URL;

export const loadTranslations = createAsyncThunk(
	'translation/loadTranslations',
	async (language, { rejectWithValue }) => {
		try {
			// Check alternativeText is present then load entitySpecific translations
			const hasAlternativeText = Boolean(global.alternativeText);
			let url;
			if (hasAlternativeText && global.entityId) {
				url = `${BASE_URL}/${global.entityId}/${language}.json`;
			} else {
				url = `${BASE_URL}/default/${language}.json`;
			}
			const response = await fetch(url);
			if (response.status === 200) {
				const data = await response.json();
				return { translations: data, language };
			}
			// Fallback to local if remote fails
			const localResponse = await import(`../translations/${language}.json`);
			return { translations: localResponse.default, language };
		} catch (error) {
			return rejectWithValue({ translations: enTranslations, language: 'en' });
		}
	}
);

const translationSlice = createSlice({
	name: 'translation',
	initialState: {
		translations: {},
		currentLanguage: 'en',
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(loadTranslations.fulfilled, (state, action) => {
				state.translations = action.payload.translations;
				state.currentLanguage = action.payload.language;
			})
			.addCase(loadTranslations.rejected, (state, action) => {
				state.translations = action.payload.translations;
				state.currentLanguage = action.payload.language;
			});
	},
});

export default translationSlice.reducer;
